import { useQuery } from 'react-query';
import { queryKeys } from '../../services/query-key/query-keys';
import { getPrivateApi } from '../../services/api';
import { GetCustomerStatusCountsResponseSchema } from '@vy/api-definition';

export function useCustomersCountByStatus() {
  return useQuery({
    queryKey: queryKeys.customersCountByStatus(),
    queryFn: async () => {
      const api = getPrivateApi();
      const customersCountByStatus = await api.getCustomerStatusCounts();

      return GetCustomerStatusCountsResponseSchema.parse(customersCountByStatus);
    },
  });
}
